<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" href="/">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appIconImage }}" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->

    <!-- Toggle skin -->
    <li class="nav-item d-none d-lg-block">
      <a class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" [ngbTooltip]="currentSkin === 'dark' ? 'Light mode' : 'Dark mode'" class="ficon font-medium-5 feather"></span>
      </a>
    </li>
    <!--/ Toggle skin -->

    <!-- chat -->
    <div class="nav-item d-none d-lg-block">
      <a class="nav-link nav-link-style btn position-relative" id="chat-header-button" [routerLink]="'/dashboard/chat'" *ngIf="_utilsService.moduleIsActive('chat')">
        <span [data-feather]="'message-square'" class="ficon font-medium-5"></span>
        <span class="badge badge-pill badge-primary badge-up cart-item-count" *ngIf="chatNotification || chatNotification > 0">{{ chatNotification }}</span>
      </a>
    </div>
  </div>

  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- ? Language selection | Uncomment if needed-->
    <li ngbDropdown class="nav-item dropdown dropdown-language" *ngIf="coreConfig.layout.languageSelector">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
      >
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)"> <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }} </a>
      </div>
    </li>
    <!--/ Language selection -->
    <app-navbar-notification></app-navbar-notification>

    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user">
      <a class="nav-link dropdown-toggle dropdown-user-link" *ngIf="currentUser" id="dropdown-user" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
        <div class="user-nav d-sm-flex d-none">
          <span class="user-name font-weight-bolder">{{ currentUser.firstname }} {{ currentUser.lastname }}</span>
          <span class="user-status">{{ currentUser.figure }}</span>
        </div>
        <span class="avatar">
          <img *ngIf="currentUser.avatar && currentUser.avatar.length > 0" class="round" alt="avatar" height="40" width="40" [src]="currentUser.avatar" />
          <span class="avatar-status-{{currentUser.status || 'online'}}"></span>
        </span>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <a ngbDropdownItem [routerLink]="['/dashboard/user/profile']"> <span [data-feather]="'user'" [class]="'mr-50'"></span> {{ "MENU.PROFILE" | translate }} </a>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem [routerLink]="['/auth/logout']"> <span [data-feather]="'power'" [class]="'mr-50'"></span> {{ "LOGOUT" | translate }} </a>
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>
